module.exports = __webpack_public_path__ + "img/12.9cfb9e9a.jpg";